export default "__VITE_ASSET__CBJwbWPl__"